<template>
  <div class="feedback-view">
    <PageBanner
      title="Feedback"
      imageSrc="../assets/images/rice-7176354_1280.jpg"
      altText="Services Banner"
    />
    <main class="container" role="main">
      <section class="grid" aria-label="Feedback">
        <div class="left" style="width: 100%">
          <div class="card" style="max-width: 1100px; margin: 0 auto">
            <!-- FeedbackForm contains the banner and the form -->
            <FeedbackForm :api-endpoint="apiEndpoint" />
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import FeedbackForm from "@/components/FeedbackForm.vue";
import PageBanner from "@/components/PageBanner.vue";

export default {
  name: "FeedbackView",
  components: { FeedbackForm, PageBanner },
  data() {
    return {
      apiEndpoint: "/api/contact", // change if your backend endpoint differs
    };
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 0 auto;
  padding: 0 0 60px; /* keep bottom padding */
  background: #f6f8fb; /* optional: same bg as form */
}

@media (min-width: 880px) {
  .grid {
    justify-items: center;
  }
}
</style>
